export interface ISourceViewData {
    id: string;
    name: string;
    description: string;
    code: string;
    width: number;
    stripLength: any;
  }
  
  export interface ISourceViewLabel {
    descriptionLabel: string;
    codeLabel: string;
  }
  
  export default class SourceViewData implements ISourceViewData, ISourceViewLabel {
    id: string;
    name: string;
    description: string;
    code: string;
    width: number;
    stripLength: any;
  
    descriptionLabel: string;
    codeLabel: string;
  
    constructor(id: string, name: string, description: string, code: string, width: number, stripLength: any) {
      this.id = id;
      this.name = name;
      this.description = description;
      this.code= code;
      this.width= width;
      this.stripLength = stripLength;
  
      this.descriptionLabel = "Description";
      this.codeLabel= "Source Code";
    }
  }
  
  const defaultSourceData = new SourceViewData("", "", "", "", 0, 10000);
  export {defaultSourceData};
  